<div id="les-plus-form" class="px-4 mb-4">
  <form class="d-flex align-items-end justify-content-between w-50">
    <p-input
      [formControl]="this.perksForm.controls.perk"
      id="perk"
      name="perk"
      label="Liste des plus (12 max.)"
      [disabled]="isMaxPerksReached"
      [maxLength]="50"
      [showCounter]="true"
      class="flex-grow-1 me-2"
    ></p-input>

    <p-button
      label="Ajouter"
      level="primary"
      type="button"
      [disabled]="isAddPerkDisabled"
      [title]="addPerkTitle"
      (click)="addPerk()"
    ></p-button>
  </form>

  <div class="row pt-3">
    <span
      *ngFor="let perk of newPerks.items"
      class="col-3 mb-3 d-block overflow-hidden"
    >
      <div class="d-flex">
        <span>{{ perk }}</span>
        <i-feather
          name="x-circle"
          class="text-danger ms-1"
          (click)="deletePerk(perk)"
        ></i-feather>
      </div>
    </span>
  </div>
</div>
